import { setShowAddCoverageModal } from "reducers/future-medical";
import { useDispatch, useSelector } from "utils/redux";

import { AddCoverageModal } from "../modals/AddCoverageModal";

type QuerySectionModalsProps = {
  fileId: number;
  organization: number;
};

export const QuerySectionModals = ({
  fileId,
  organization,
}: QuerySectionModalsProps) => {
  const dispatch = useDispatch();
  const showAddCoverageModal = useSelector(
    (state) => state.futureMedical.showAddCoverageModal,
  );

  return (
    <AddCoverageModal
      isOpen={showAddCoverageModal}
      onClose={() => dispatch(setShowAddCoverageModal(false))}
      fileId={fileId}
      organization={organization}
    />
  );
};
